export default __webpack_public_path__ + "static/media/4.d274dcb2.png";